// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import AccountSideMenu from 'Containers/AccountSideMenu/AccountSideMenu';
import Reports from 'Containers/Reports/Reports';

const StyledReportsPage = styled.div`
  display: grid;
  grid-template-columns: 260px auto;
  grid-column-gap: 30px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: auto;

    aside {
      display: none;
    }
  }
`;

const ReportsPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};

  let reportsPageClassNames = bodyAttributes?.class || '';
  if (!reportsPageClassNames.includes('ReportsPage')) {
    reportsPageClassNames += 'ReportsPage';
  }

  return (
    <>
      <Helmet>
        <body className={ reportsPageClassNames } />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('common.pages.reports.reports') }</title>
      </Helmet>
      <StyledReportsPage theme={ theme } className="grid-container">
        <AccountSideMenu />
        <Reports />
      </StyledReportsPage>
    </>
  );
});

ReportsPage.displayName = 'ReportsPage';

export default ReportsPage;
